import { useAutomations } from "@/context/AutomationsProvider";
import { Card, CardContent } from "../ui/card";

import { PipelineDataCardList } from "./PipelineDataCardList";
import { PipelineDataTable } from "./PipelineDataTable";

export function PipelineDataSection() {
  const { all: pipelines, isLoading, processes } = useAutomations();

  return (
    <>
      <PipelineDataCardList pipelines={pipelines} />
      <div className="hidden py-4 lg:block">
        <Card
          className={
            "h-full w-full border-0 shadow-none"
          }
        >
          <CardContent className="p-3">
             <PipelineDataTable pipelines={pipelines ?? []} processes={processes} isLoading={isLoading} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}